import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { BonsaiLogo } from "@/components/BonsaiLogo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password aggiornata");
      navigate("/login");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-secondary">
      <div className="w-full max-w-md">
        <div className="mb-8 flex justify-center"><BonsaiLogo size={30} /></div>
        <div className="bg-white border border-border rounded-2xl p-8">
          <h2 className="text-2xl font-extrabold text-navy">Nuova password</h2>
          <form onSubmit={submit} className="space-y-4 mt-6">
            <div>
              <Label htmlFor="password">Nuova password</Label>
              <Input id="password" type="password" required value={password}
                data-testid="reset-password-input"
                onChange={(e) => setPassword(e.target.value)} className="mt-1.5" />
            </div>
            {error && <p className="text-sm text-destructive">{error}</p>}
            <Button type="submit" disabled={loading || !token} data-testid="reset-submit-button" className="w-full h-11 font-bold">
              {loading ? "Salvataggio..." : "Reimposta password"}
            </Button>
          </form>
          <div className="mt-4 text-center">
            <Link to="/login" className="text-sm text-accent font-semibold hover:underline">Torna al login</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
